import React from 'react';
import ReactDOM from 'react-dom';
import ExifReader from 'exifreader/dist/exif-reader';
import Modal from '../../Modal/ReactBootstrapModal';
import styles from './addPhoto.scss';

const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
const p = require('pica/dist/pica')();

export class AddPhotoError extends React.Component {
    componentDidMount() {
        this.el = window.document.createElement('div');
        this.appRoot = window.document.getElementById('myutr-app-wrapper');
        this.appRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        this.appRoot.removeChild(this.el);
    }

    render() {
        if (this.el) {
            return ReactDOM.createPortal(
                <Modal visible={!!this.props.loadError} dialogClassName="modal-lg">
                    <div className="modal-header">
                        <div className="text-medium">Image Load Error</div>
                        <div className="close-icon" data-testid="add-photo.close-error-btn" onClick={this.props.closeError}><i className="utr utr-close" /></div>
                    </div>
                    <div className={`modal-body`}>
                        <div>
                            <div className="text-center">
                                {this.props.loadError}
                            </div>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-primary text-uppercase float-right"
                                    data-testid="add-photo.error-ok-btn"
                                    onClick={this.props.closeError}
                                >
                                    Ok
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>,
                this.el,
            );
        }
        return null;
    }
}

class AddPhoto extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadError: null,
        };
        this.handleUploadImage = this.handleUploadImage.bind(this);
        this.handleCloseError = this.handleCloseError.bind(this);
    }

    handleCloseError() {
        this.setState({ loadError: null });
    }

    handleUploadImage(ev) {
        ev.preventDefault();
        const imageFile = ev.target.files[0];

        // verify image type as correct
        if (!validTypes.includes(imageFile.type)) {
            this.setState({ loadError: 'Invalid file type. Accepted formats are Jpeg, Png, and Gif' });
            return;
        }
        this.props.uploadStart();
        const $this = this;
        $this.orientation = null;
        const img = new Image();
        img.onload = (e) => {
            const loadedImage = e.target;
            const canvas = window.document.createElement('canvas');
            canvas.width = loadedImage.width;
            canvas.height = loadedImage.height;
            const maxWidth = $this.props.maxSize || 1024;
            const maxHeight = $this.props.maxSize || 1024;
            // restrict image to max bounds
            if (loadedImage.width > maxWidth) {
                canvas.width = maxWidth;
                canvas.height = loadedImage.height * maxWidth / loadedImage.width;
            }
            if (canvas.height > maxHeight) {
                canvas.height = maxHeight;
                canvas.width = loadedImage.width * maxHeight / loadedImage.height;
            }
            if (canvas.width !== loadedImage.width || canvas.height !== loadedImage.height) {
                p.resize(loadedImage, canvas, {
                    unsharpAmount: 80,
                    unsharpRadius: 0.6,
                    unsharpThreshold: 2,
                })
                    .then(result => p.toBlob(result, imageFile.type))
                    .then(blob => $this.props.uploadPhoto(
                        {
                            file: blob,
                            orientation: $this.orientation,
                            extension: imageFile.name.substr(imageFile.name.lastIndexOf('.')),
                        },
                    ))
                    .catch(error => {
                        console.log('ERROR', error);
                        $this.setState( // TODO: clear url
                            { loadError: 'There was a problem processing your file, make sure it is under 10 Mb and is Jpeg, Png, or Gif format' },
                        );
                    });
            } else {
                $this.props.uploadPhoto({
                    file: imageFile,
                    orientation: $this.orientation,
                    extension: imageFile.name.substr(imageFile.name.lastIndexOf('.')),
                });
            }
        };
        const reader = new FileReader();
        reader.onload = (readerEvent) => {
            try {
                // parse out the exif orientation
                const tags = ExifReader.load(readerEvent.target.result, { expanded: true });
                $this.orientation = tags.exif.Orientation.value;
            } catch (error) {
                console.log(error);
            }
            img.src = window.URL.createObjectURL(imageFile);
        };
        reader.readAsArrayBuffer(imageFile);
        ev.target.value = '';
    }

    render() {
        let style = '';
        switch (this.props.style) {
            case 1:
                style = styles.profileBtn;
                break;
            case 2:
                style = styles.bannerBtn;
                break;
            case 3:
                style = `btn btn-default btn-lg text-uppercase ${styles.galleryBtn}`;
                break;
            default:
                break;
        }
        return (
            <React.Fragment>
                <label ref={this.props.inputRef} className={`${style} ${this.props.addSponsorImage ? styles.noOpacity : ''}`} data-testid={this.props['data-testid'] || undefined}>
                    <i />
                    <div>{this.props.text}</div>
                    <input onChange={this.handleUploadImage} type="file" accept="image/png,image/jpeg,image/gif" data-testid="add-photo.file-input" />
                </label>
                <AddPhotoError loadError={this.state.loadError} closeError={this.handleCloseError} />
            </React.Fragment>
        );
    }
}

export default AddPhoto;
